import { LOGIN_INFO, WARD_INFO } from '../../../comm/constant';
import { checkLocalStroage } from '../../../utils/check';
import {
  GET_LOGININFO,
  UPDATE_LOGININFO,
  CHANGE_LOGININFO_WARD,
  GET_WARDINFO,
  UPDATE_WARDINFO,
  INIT_LOGIN_INFO,
} from '../../constant';
const initWardInfo = () => {
  checkLocalStroage();
  const info = localStorage.getItem(WARD_INFO);
  const initWardinfo = info
    ? { ...JSON.parse(info), flag: true }
    : {
        flag: false,
        hospitalName: '',
        wardName: '',
      };
  return initWardinfo;
};

const initLoginInfo = () => {
  checkLocalStroage();
  const WP_LOGIN_INFO = localStorage.getItem(LOGIN_INFO);
  const initWP_LOGIN_INFO = WP_LOGIN_INFO
    ? { ...initWardInfo(), ...JSON.parse(WP_LOGIN_INFO), flag: true }
    : {
        ...initWardInfo(),
        flag: false,
      };
  return initWP_LOGIN_INFO;
};

const wardInfo = (state = initWardInfo(), action) => {
  const { type, data } = action;
  switch (type) {
    case GET_WARDINFO:
      return state;
    case UPDATE_WARDINFO:
      return data;
    case CHANGE_LOGININFO_WARD:
      return { ...state, ward: data.ward };
    default:
      return state;
  }
};

const loginInfo = (state = initLoginInfo(), action) => {
  const { type, data } = action;
  switch (type) {
    case GET_LOGININFO:
      return state;
    case UPDATE_LOGININFO:
      return data;
    case INIT_LOGIN_INFO:
      return initLoginInfo();
    default:
      return state;
  }
};

export { wardInfo, loginInfo };
